import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getOurFranchises = async () => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/our_franchises/`, {
        headers: { Authorization: token }
    });
};

export const addOurFranchise = async (formData) => {
    const token = await cookie.get("token");
    return await axios.post(`${proxy}/our_franchises/create`, formData, {
        headers: { Authorization: token }
    });
};

export const deleteOurFranchises = async (id) => {
    const token = await cookie.get("token");
    return await axios.delete(`${proxy}/our_franchises/delete/${id}`, {
        headers: { Authorization: token }
    });
};